import CreateCampaignDialog from '@/components/CreateCampaignDialog'
// TODO uncomment when will implement a support chat
// import ChatIcon from '@/components/Icons/ChatIcon'
import buttonsStyles from '@/styles/buttons.module.css'
import { useState } from 'react'
import profileStyles from './styles.module.css'

interface DynamicHeaderProps {
  brandLogoUrl?: string
  title: string
  subTitle: string
}

const DynamicHeader = ({ brandLogoUrl, title, subTitle }: DynamicHeaderProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const handleOpenDialog = () => setIsDialogOpen(true)
  const handleChangeDialog = (open: boolean) => setIsDialogOpen(open)

  return (
    <div className={profileStyles.header}>
      <div className={profileStyles['header-title-wrapper']}>
        <h2 className={profileStyles['header-title']}>{title}</h2>
        <p className={profileStyles['header-subTitle']}>{subTitle}</p>
      </div>
      <div className={profileStyles['header-actions']}>
        <button type="button" className={buttonsStyles['button-primary']} onClick={handleOpenDialog}>
          + Create Campaign
        </button>
        {/*  TODO uncomment when will implement a support chat */}
        {/*<div className={profileStyles['header-chat-icon']}>*/}
        {/*  <ChatIcon size={24} />*/}
        {/*</div>*/}
        <span className={profileStyles.divider} />
        <div className={profileStyles['header-avatar-logo']}>
          <img
            src={brandLogoUrl ?? '/placeholder.jpg'}
            loading="lazy"
            alt={'logo'}
            onError={(e) => {
              e.currentTarget.src = '/placeholder.jpg'
            }}
          />
        </div>
      </div>
      <CreateCampaignDialog open={isDialogOpen} onOpenChange={handleChangeDialog} />
    </div>
  )
}

export default DynamicHeader
